export default function() {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "所属门店", prop: "store_id", width: 200, slots: "store_id" },
    { label: "订单类型", prop: "type", slots: "type", width: 100 },
    { label: "订单编号", prop: "orderNumber", width: 200 },
    { label: "订单状态", prop: "status", slots: "status" },
    // { label: "openid", prop: "openid" },
    { label: "手机号", prop: "phone", width: 130 },
    { label: "订单金额", prop: "cost", width: 100 },
    { label: "实际支付金额", prop: "realityCost", width: 100 },
    {
      label: "支付方式",
      prop: "payStyle",
      slots: "payStyle",
      width: 140,
    },
    { label: "订单明细", prop: "detail", slots: "detail", width: 350 },
    { label: "订单备注", prop: "odescribe" },
    {
      label: "订单创建时间",
      prop: "createTime",
      width: 180,
      // slots: "state",
    },
    {
      label: "操作",
      prop: "operation",
      width: 120,
      slots: "operation",
      fixed: "right",
    },
  ];
}
